<section class="specialtestbanner-area" id="hero-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="specialtest-img">
                    <img src="assets/img/neet-landing/test-banner.png" class="specialtestbanner" alt="">
                </div>
            </div>

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="specialtest-contents">
                    <h1 class="specialtest-title">FINALE</h1>
                    <p>Final Infinity National Learner's Exam</p>
                    <h5>Dates: 23rd September 2021 for IIT JEE (Advanced)</h5>
                    <!-- <h6>Date: 30<sup>th</sup> August 2021</h6> -->
                    <div class="specialnumbertest-field" [formGroup]='mobileNumberForm'>
                        <span class="code">+ 91</span>
                        <input type="tel" maxlength="10" class="specialnumbertest-input" (onchange)="onInputChange()"
                            (keyup)="onInputChange()" placeholder="MOBILE NUMBER" formControlName='mobilenumber'>
                        <button type="button" (click)="signup('neet_ss_1', {number: mobileNumberForm.value.mobilenumber, dialCode: '+91'})" [disabled]="!mobileNumberValid"
                            class="specialtest-btn"><b>START LEARNING </b></button>
                    </div>
                    <div class="d-flex justify-content-center IL_sc-click assessment_mb-25 font-weight-bold">
                        <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                    </div>
                    <!-- <small class="nofee">No Exam Fee, Enroll Now</small> -->
                    <!--h4>Top 10 Students will get a</h4>
                    <h3>FREE Android Tablet!</h3-->
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content specialtest-registerpopup">
                <div class="specialtest-popup">
                    <h1>One more step and you are all set</h1>
                    <button type="button" class="close specialtest-bg-close" data-dismiss="modal"
                        aria-label="Close"><span aria-hidden="true" class="bg-close">&times;</span>
                    </button>


                </div>
                <div class="modal-body">

                    <form class="form-horizontal">
                        <div class="form-group disable-color">
                            <span class="input-icon"><img src="assets/img/neet-landing/phone.png" alt=""></span>
                            <input class="form-control " type="text" placeholder="99999 99999" disabled>
                        </div>
                        <div class="form-group">
                            <span class="input-icon"><img src="assets/img/neet-landing/user.png" alt=""></span>
                            <input class="form-control" type="text" placeholder="Name">
                        </div>
                        <div class="form-group">
                            <span class="input-icon"><img src="assets/img/neet-landing/mail.png" alt=""></span>
                            <input class="form-control" type="email" placeholder="Email">
                        </div>
                        <div class="specialtest-select-gr">
                            <span class="input-icon"><img src="assets/img/neet-landing/file-text.png" alt=""></span>
                            <select name="" id="" class="specialtest-learn-pop">
                                <option value="0">Select Option</option>
                                <option value="1">Grade</option>
                                <option value="2">JEE</option>
                            </select>
                        </div>
                        <div class="specialtest-whatsapp text-center">
                            <label class="specialtest-updates UNFAPP-whtapp-chkarea">
                                <input type="checkbox"><span class="whtschkcnt">Receive updates on Whatsapp</span>
                            </label>
                        </div>
                        <div class="specialtest-signinterms">
                            <p>By Signing up, you are agreeing to our <a href="#" class="specialtest-terms">Terms &
                                    Conditions and Privacy
                                    Policy</a></p>
                        </div>
                        <button type="button" class="specialtest-regnow" data-toggle="mymodal"
                            data-target="#exampleModalCenter2">REGISTER NOW</button>
                    </form>
                </div>

            </div>
        </div>
    </div>
</section>
<!-- Grand -->
<section class="grandfeature-area">
    <div class="container">
        <div class="specialfeature-head">
            <h1>Grand Prizes for<span class="free-color"> IIT JEE (Advanced) 2021</span> Toppers*</h1>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="grand-box">
                    <div class="grand-icon">
                        <figure>
                            <img src="assets/img/cup.png" alt="">
                        </figure>
                    </div>
                    <h4>Rank 1 - 10</h4>
                    <p>Vouchers Upto 5 Lacs</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="grand-box">
                    <div class="grand-icon">
                        <figure>
                            <img src="assets/img/cup.png" alt="">
                        </figure>
                    </div>
                    <h4>Rank 11 - 100</h4>
                    <p>Vouchers Upto 1 Lac</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="grand-box">
                    <div class="grand-icon">
                        <figure>
                            <img src="assets/img/cup.png" alt="">
                        </figure>
                    </div>
                    <h4>Rank 101 - 1000</h4>
                    <p>Vouchers Upto 25k</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <p class="tandc"><a href="#">T&C Apply</a> <span>&nbsp;Grand prizes are applicable for students who will take Finale & gets top rank in IIT JEE (Advanced) 2021 final exam</span></p>
                
            </div>
        </div>
    </div>
</section>
<!-- special feature area -->
<section class="specialfeature-area">
    <div class="container">
        <div class="specialfeature-head">
            <h1>Features of <span class="free-color">FINALE</span></h1>
            <!-- <p>NEET UG 2021</p> -->
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="specialfeature-box">
                    <div class="specialfeature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f1_yellow.png" alt="">
                        </figure>
                    </div>
                    <h4>All India Ranking</h4>
                    <p>Benchmark your performance with more than 1 lac students.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="specialfeature-box-bgyellow">
                    <div class="specialfeature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f2.png" alt="">
                        </figure>
                    </div>
                    <h4>Analysis</h4>
                    <p>Get detailed analysis of each test to help you work on the improvement plan.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="specialfeature-box">
                    <div class="specialfeature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f3_yellow.png" alt="">
                        </figure>
                    </div>
                    <h4>Edge Over Others</h4>
                    <p>Prepared by top faculties who aim at producing top ranks, and get you an edge over other similar
                        test series.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="specialfeature-box-bgyellow">
                    <div class="specialfeature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f4.png" alt="">
                        </figure>
                    </div>
                    <h4>Multi Device</h4>
                    <p>You can take your test either on Phone, Tablet or Laptop / Desktop.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="specialfeature-box">
                    <div class="specialfeature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f5_yellow.png" alt="">
                        </figure>
                    </div>
                    <h4>Syllabus Coverage</h4>
                    <p>The test series is based on complete syllabus and as per new pattern to help to you perform
                        better.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="specialfeature-box-bgyellow">
                    <div class="specialfeature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f6.png" alt="">
                        </figure>
                    </div>
                    <h4>Added Advantage</h4>
                    <p>Clarify your doubts with Infinitylearn doubts app, get your answers for FREE.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Infinity Learn FINALE -->
<section class="grandfeature-area">
    <div class="container">
        <div class="specialfeature-head">
            <h1>Infinity Learn FINALE</h1>
            <h5>Select the right test for you</h5>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <div class="il-grand-box">
                    <div class="il-grand-jee">
                    </div>
                    <h3>IIT JEE (Advanced) FINALE 2021</h3>
                    <h5>23rd September, 9 AM to 12 PM</h5>
                    <h6><strong>Paper 1</strong></h6>


                    <div class="tab-flex">
                        <div class="tab-img">
                            <figure>
                                <img src="assets/img/alarm.png" alt="">
                            </figure>
                        </div>
                        <div class="gradecontent">
                            <a href="javascript:void(0);"><strong>180 mins</strong></a>
                        </div>
                    </div>
                    <div class="tab-flex">
                        <div class="tab-img">
                            <figure>
                                <img src="assets/img/content.png" alt="">
                            </figure>
                        </div>
                        <div class="gradecontent">
                            <a href="javascript:void(0);"><strong>Physics, Chemistry and Mathematics</strong></a>
                        </div>
                    </div>
                    <div class="tab-flex">
                        <div class="tab-img">
                            <figure>
                                <img src="assets/img/edit.png" alt="">
                            </figure>
                        </div>
                        <div class="gradecontent">
                            <a href="javascript:void(0);"><strong>Total of 54 questions</strong></a>
                        </div>
                    </div>
                    <div>
                        <a><button type="button" (click)="openSignUpDialog(true)" class="il-reggrandneetbtn">Register for FREE </button></a>
                    </div>   
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xs-12">
                <div class="il-grand-box">
                    <div class="il-grand-jee">
                    </div>
                    <h3>IIT JEE (Advanced) FINALE 2021</h3>
                    <h5>23rd September, 2:30 PM to 5:30 PM</h5>
                    <h6><strong>Paper 2</strong></h6>

                    <div class="tab-flex">
                        <div class="tab-img">
                            <figure>
                                <img src="assets/img/alarm.png" alt="">
                            </figure>
                        </div>
                        <div class="gradecontent">
                            <a href="javascript:void(0);"><strong>180 mins</strong></a>
                        </div>
                    </div>
                    <div class="tab-flex">
                        <div class="tab-img">
                            <figure>
                                <img src="assets/img/content.png" alt="">
                            </figure>
                        </div>
                        <div class="gradecontent">
                            <a href="javascript:void(0);"><strong>Physics, Chemistry and Mathematics</strong></a>
                        </div>
                    </div>
                    <div class="tab-flex">
                        <div class="tab-img">
                            <figure>
                                <img src="assets/img/edit.png" alt="">
                            </figure>
                        </div>
                        <div class="gradecontent">
                            <a href="javascript:void(0);"><strong>Total of 54 questions</strong></a>
                        </div>
                    </div>
                    <div>
                        <a ><button type="button" (click)="openSignUpDialog(true)" class="il-reggrandneetbtn">Register for FREE </button></a>
                    </div>   
                </div>
            </div>
        </div>
        
    </div>
</section>
<!-- Exam Date area -->
<!-- <section class="examdate-area">
    <div class="container">
        <div class="examdate-head">
            <h1>Test Series
                br>Exam date - 13th August 2021<
            </h1>
            <p>Last chance to test yourself among lacs of students and improve your rank. The test series is built
                focusing on the
                real test pattern and most important questions. It covers the full syllabus and has been specially
                created by top
                faculties of India.</p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="examdate-box">
                    <div class="examdate-icon">
                        <figure>
                            <img src="assets/img/neet-landing/neet.png" alt="">
                        </figure>
                    </div>
                    <h4>NEET 2021</h4>
                    <a href="#"><button type="button" class="test-btn">START FOR FREE</button></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="examdate-box">
                    <div class="examdate-icon">
                        <figure>
                            <img src="assets/img/neet-landing/jeemain.png" alt="">
                        </figure>
                    </div>
                    <h4>JEE Main 2021</h4>
                    <a href="#"><button type="button" class="test-btn">START FOR FREE</button></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="examdate-box">
                    <div class="examdate-icon">
                        <figure>
                            <img src="assets/img/neet-landing/jeeadvanced.png" alt="">
                        </figure>
                    </div>
                    <h4>JEE Advanced 2021</h4>
                    <a href="#"><button type="button" class="test-btn">START FOR FREE</button></a>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-xs-12 ">
                <div class="specialnumbertest-field number-center-two">
                    <span class="code">+ 91</span>
                    <input type="tel" maxlength="10" class="specialnumbertest-input" (onchange)="onInputChange()"
                        (keyup)="onInputChange()" placeholder="MOBILE NUMBER" [(ngModel)]="mobileNumber">
                    <button type="button" (click)='openDialog()' [disabled]="!mobileNumberValid"
                        class="specialtest-btn"><b>START LEARNING </b></button>
                </div>
            </div>
        </div>
    </div>
</section> -->





<!-- number field two-->
<section class="numberfield-area-two">
    <div class="container">
        <div class="field-head">
            <h1>Free Test Series</h1>
            <p>Take this free test to prepare yourself better before the actual exam.</p>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-xs-12 ">
                <div class="specialnumbertest-field number-center-two" [formGroup]='mobileNumberForm'>
                    <span class="code">+ 91</span>
                    <input type="tel" maxlength="10" class="specialnumbertest-input" (onchange)="onInputChange()"
                        (keyup)="onInputChange()" placeholder="MOBILE NUMBER" formControlName='mobilenumber'>
                    <button type="button" (click)="signup('neet_ss_2', {number: mobileNumberForm.value.mobilenumber, dialCode: '+91'})"  [disabled]="!mobileNumberValid"
                        class="specialtest-btn"><b>START LEARNING </b></button>
                </div>
                <div class="d-flex justify-content-center IL_sc-click white font-weight-bold">
                    <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- special Footer Section Starts -->
<app-footer></app-footer>
<!-- Footer Section Ends -->
<script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js"
    integrity="sha384-9/reFTGAW83EW2RDu2S0VKaIzap3H66lZH81PoYlFhbGU+6BZp6G7niu735Sk7lN"
    crossorigin="anonymous"></script>